import sanityClient from '@sanity/client';

export default sanityClient({
  projectId: 'qr4omgu6',
  dataset: 'production',
  apiVersion: '2021-08-31',
  useCdn: true,
});
